import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const PaymentTypeCheckBox = ({isActive, setActiveOrDeactive, label}) => {
    return (
        <div className={isActive ? "checkbokitem active" : "checkbokitem"} onClick={() => setActiveOrDeactive(!isActive)}>
            <div className="icon-box">
                <FontAwesomeIcon icon={faCheck} />
            </div>
            <span className='label'>{label && label}</span>
        </div>
    )
}

export default PaymentTypeCheckBox
